export default "__VITE_ASSET___LnvEvtP__"